import React from 'react'

import { Design991 } from '@components/cases/Design991'
import { CustomHead } from '@ui/sections/CustomHead'

function Design991Page() {
  return (
    <>
      <CustomHead
        title="Design 991 e-learning platform"
        description="We built a marketplace offering online courses on UI, UX marketing design, and a variety of other topics created by practicing industry professionals."
        imagePath="/images/custom-head/custom-head-design-911.webp"
      />
      <Design991 />
    </>
  )
}

export default Design991Page
